"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.createInputState = createInputState;
// @TODO, rules could potentially change after initial register. should there be way to re-init?
function createInputState(inputElement, rules) {
  return {
    payload: {
      inputElement,
      rules
    },
    type: 'createInputState'
  };
}